import { api } from 'api';
import log from 'loglevel';
import { call, cancelled, put, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { EffectR } from 'types/utils';
import { postReviewForm } from '../utils/api';
import { PostReviewRequestError, PostReviewRequestErrorContent } from '../types';
import { POST_REVIEW } from '../actions/post-reviews';

export function* postReviewSagas() {
  yield takeEvery(POST_REVIEW.request, doPostReview);
}

export function* doPostReview(action: ActionType<typeof POST_REVIEW.request>) {
  const abortController = api.abortController();
  try {
    const formData = action.payload;
    const result = (yield call(postReviewForm, formData)) as EffectR.Call<typeof postReviewForm>;

    yield put(POST_REVIEW.success(result));
  } catch (e) {
    log.error(e);
    if (log.getLevel() <= log.levels.DEBUG && typeof e === 'object') {
      log.debug('error: ', { ...e });
    }

    let failureContent: PostReviewRequestError = String(e);
    const errors = (e as PostReviewRequestErrorContent)?.response?.data?.postReviewErrors ?? null;

    if (errors instanceof Array) {
      failureContent = errors;
    } else if (e instanceof Error) {
      failureContent = e.message;
    }

    yield put(POST_REVIEW.failure(failureContent));
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield put(POST_REVIEW.cancel());
    }
  }
}
